module.exports = KsysAppTemplateV2dot125dot0;